import styled from 'styled-components';
import theme from 'styles/theme';

export const TaskTimeWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const TaskTimeItem = styled.div`
  display: flex;
  gap: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
`;

export const TaskTimeTitle = styled.div`
  color: ${theme.colors.mainDarkBlue};
`;

export const TaskTimeValue = styled.div`
  color: ${theme.colors.lightBlue};
`;
